module.exports = __webpack_public_path__ + "img/apps_any_img.c52ee228.svg";